import { Box, Button, Container, Heading, Stack, Text, useBreakpointValue, useColorModeValue } from '@chaine/keychaine';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
export const CallToActionBanner = (props) => {
    const { title, description, buttonText, linkTo } = props;
    return (React.createElement(Container, { py: { base: '16', md: '24' } },
        React.createElement(Box, { bg: "bg-surface", boxShadow: useColorModeValue('sm', 'sm-dark'), borderRadius: "xl", px: { base: '6', lg: '16' }, py: { base: '10', lg: '16' } },
            React.createElement(Stack, { spacing: "8", direction: { base: 'column', lg: 'row' }, justify: "space-between" },
                React.createElement(Stack, { spacing: "4", maxW: "2xl" },
                    React.createElement(Heading, { size: "sm" }, title),
                    React.createElement(Text, { color: "muted", fontSize: useBreakpointValue({ base: 'lg', lg: 'xl' }) }, description)),
                React.createElement(Stack, { spacing: "3", direction: { base: 'column', sm: 'row' }, justify: { base: 'start' } },
                    React.createElement(NavLink, { to: linkTo },
                        React.createElement(Button, { variant: "primary", size: "lg" }, buttonText)))))));
};
